<template>
  <div>
    <a-card class="customer-filter" size="small">
      <a-page-header title="工单信息">
        <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
          <!-- 使用 gutter 让列之间有空隙 -->
          <a-row :gutter="[16, 16]">
            <!-- 标题 -->
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="标题">
                <a-input v-model.trim="filterForm.title" allow-clear placeholder="工单标题" @change="onSearch" />
              </a-form-model-item>
            </a-col>

            <!-- 问题类型 -->
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="问题类型">
                <a-tree-select v-model="filterForm.tags" show-search multiple :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" style="width: 100%" :tree-data="showTagList" @change="onSearch" />
              </a-form-model-item>
            </a-col>

            <!-- 状态 -->
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="状态">
                <a-select v-model="filterForm.status" mode="multiple" allow-clear placeholder="状态" @change="onSearch">
                  <a-select-option v-for="(item, index) in ticketStatus" :key="index" :value="item.value">
                    <a-badge :status="item.status" :color="item.color" :text="item.label" />
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>

            <!-- 业务域 -->
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="业务域">
                <a-select v-model="filterForm.team" mode="multiple" allow-clear placeholder="问题类型" @change="onSearch">
                  <a-select-option v-for="(item, index) in ticketDomain" :key="index" :value="item.value">
                    <a-badge :status="item.team" :color="item.color" :text="item.label" />
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>

            <!-- 展开项 -->
            <a-col v-show="expand" :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="工单排查人">
                <a-select v-model="filterForm.handler" mode="multiple" allow-clear placeholder="处理人" show-search :filter-option="utils.filterOption" @change="onSearch">
                  <a-select-option v-for="(user, index) in userData" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>

            <!-- 渠道工单ID -->
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="渠道工单id">
                <a-input v-model.trim="filterForm.qiyuTicketId" allow-clear placeholder="渠道工单id" @change="onSearch" />
              </a-form-model-item>
            </a-col>

            <!-- 来源类型 -->
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="渠道">
                <a-select v-model="filterForm.fromType" allow-clear placeholder="渠道" @change="onSearch">
                  <a-select-option v-for="(item, index) in ticketFromType" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>

            <!-- 工单ID -->
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="工单id">
                <a-input v-model.trim="filterForm.Id" allow-clear placeholder="智云工单id" @change="onSearch" />
              </a-form-model-item>
            </a-col>

            <!-- 与我相关 -->
            <a-col v-show="expand" :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="与我相关">
                <a-radio-group v-model="filterForm.about" button-style="solid" @change="onSearch">
                  <a-radio-button value="all"> 全部 </a-radio-button>
                  <a-radio-button value="about"> 与我相关 </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>

            <!-- 创建时间 -->
            <a-col v-show="expand" :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="创建时间">
                <a-range-picker v-model="timeList" @change="onSearch" />
              </a-form-model-item>
            </a-col>

            <!-- AI准确性 -->
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="ai准确性">
                <a-select v-model="filterForm.aiResult" mode="multiple" allow-clear placeholder="ai准确性" @change="onSearch">
                  <a-select-option v-for="(item, index) in ticketAiResult" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>

            <!-- 处理时长大于 -->
            <a-col :xs="{ span: 24 }" :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-model-item label="处理时长大于">
                <a-input-number v-model.number="filterForm.overTime" :min="0" :max="24" :step="1" :precision="0" :parser="val => (val === '' ? null : parseInt(val, 10))" @change="onSearch" />
              </a-form-model-item>
            </a-col>
          </a-row>

          <!-- 查询/重置按钮 -->
          <a-row :gutter="[16, 16]" style="margin-top: 16px; text-align: right">
            <a-col :span="24">
              <a-button type="primary" @click="getProblemList">查询</a-button>
              <a-button :style="{ marginLeft: '8px' }" @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </a-page-header>
    </a-card>

    <!-- 下方卡片 -->
    <a-card title="" class="filter-data">
      <span slot="extra">
        <ticket-view ref="view" :show-tag-list="showTagList" @setFilter="setFilter" />
      </span>
      <a-tabs @change="handleTabChange">
        <a-tab-pane key="1" tab="工单列表">
          <ticket-list :ticket-list="tableData" :pagination="pagination" :ticket-tag-list="problemTags" :columns="columns" @callback="handleTableChange" />
        </a-tab-pane>
        <a-tab-pane key="2" tab="超时工单">
          <!-- <ticket-list :ticket-list="tableData" :pagination="pagination" :ticket-tag-list="problemTags" :columns="columns" @callback="handleTableChange" /> -->
        </a-tab-pane>
      </a-tabs>
    </a-card>

    <!-- 弹窗组件 -->
    <problem-modal :is-show="modalVisible" :problem-id="problemId" @close="close" />
    <fault-drawer :display="faultVisible" :source-id="sourceId" @close="close" />
  </div>
</template>

<script>
import moment from 'moment';
import { userList } from '@/api/system/auth';
import { projectList } from '@/api/project/project';
import { queryTickets, ticketTags } from '@/api/event/problem';
import { ticketStatus, ticketDomain, ticketLevel, ticektTag, qiyuTicketStatus, ticketFields, ticketUserTag, ticketFromType, ticketAiResult, ticektType } from '@/utils/dictionary';

import FaultDrawer from '@/pages/event/components/FaultDrawer';
import ProblemModal from '@/pages/event/components/ProblemModal';
import TicketList from '@/pages/event/components/TicketList';
import TicketView from '@/pages/event/components/TicketView';
const columns = [
  {
    width: 20,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 140,
    scopedSlots: { customRender: 'customKey' }
  },
  {
    title: '标题',
    width: 400,
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '问题描述',
    width: 400,
    dataIndex: 'meta',
    key: 'meta',
    scopedSlots: { customRender: 'meta' }
  },
  {
    title: '附件',
    width: 450,
    // dataIndex: 'meta',
    // key: 'meta',
    scopedSlots: { customRender: 'attach' }
  },
  {
    title: '结论',
    width: 400,
    dataIndex: 'reply',
    key: 'reply',
    scopedSlots: { customRender: 'reply' }
  },
  {
    title: '紧急程度',
    width: 100,
    dataIndex: 'level',
    key: 'level',
    scopedSlots: { customRender: 'level' }
  },
  {
    title: '问题类型',
    width: 200,
    dataIndex: 'tags',
    key: 'tags',
    scopedSlots: { customRender: 'tags' }
  },
  {
    title: '渠道',
    width: 200,
    dataIndex: 'from',
    key: 'from',
    scopedSlots: { customRender: 'from' }
  },
  {
    title: '状态',
    width: 100,
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '渠道工单状态',
    width: 100,
    dataIndex: 'qiyuTicketStatus',
    key: 'qiyuTicketStatus',
    scopedSlots: { customRender: 'qiyuTicketStatus' }
  },
  {
    title: '上报客服',
    width: 100,
    dataIndex: 'creator',
    key: 'creator',
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '工单排查人',
    width: 100,
    dataIndex: 'handler',
    key: 'handler',
    scopedSlots: { customRender: 'handler' }
  },
  {
    title: '工单对接人',
    width: 200,
    dataIndex: 'maintainer',
    key: 'maintainer',
    scopedSlots: { customRender: 'maintainer' }
  },
  {
    title: '业务域',
    width: 100,
    dataIndex: 'domain',
    key: 'domain',
    scopedSlots: { customRender: 'domain' }
  },
  {
    title: '用户反馈时间',
    width: 164,
    dataIndex: 'userCreateTime',
    key: 'userCreateTime'
  },
  {
    title: '渠道工单创建时间',
    width: 164,
    dataIndex: 'qiyuCreatedTime',
    key: 'qiyuCreatedTime'
  },
  {
    title: '上报产研时间',
    width: 164,
    dataIndex: 'created_time',
    key: 'created_time',
    sorter: true
  },

  {
    title: '接手时长',
    width: 164,
    dataIndex: 'isOverTime',
    key: 'isOverTime',
    scopedSlots: { customRender: 'isOverTime' }
  },
  {
    title: '渠道工单id',
    width: 164,
    dataIndex: 'qiyuTicketId',
    key: 'qiyuTicketId'
  },
  {
    title: 'AI准确性',
    width: 164,
    dataIndex: 'aiResult',
    key: 'aiResult',
    scopedSlots: { customRender: 'aiResult' }
  }
];
export default {
  components: { ProblemModal, FaultDrawer, TicketList, TicketView },
  data() {
    return {
      loading: false,
      columns,
      columnsCopy: JSON.parse(JSON.stringify(columns)),
      expand: true,
      sourceId: null,
      problemId: null,
      timeList: [],
      ticketDomain,
      ticketFromType,
      ticektType,
      ticketLevel,
      ticketFields,
      ticketUserTag,
      ticketStatus,
      ticketAiResult,
      ticektTag,
      qiyuTicketStatus,
      problemTags: [],
      showTagList: [],
      userData: [],
      projects: [],
      filterForm: {
        pageSize: 20,
        overTime: 0,
        type: [1],
        pageNumber: 1,
        sortedBy: '',
        sortedMethod: ''
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 20, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      faultVisible: false,
      modalVisible: false,
      tableData: []
    };
  },
  computed: {
    project() {
      return projects => {
        const temp = projects.map(p => {
          return p.name;
        });
        return temp.join('; ');
      };
    },
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    }
  },
  mounted() {
    this.getProblemList();
    this.getProjectList();
    this.getUserList();
    this.getTicketTags();
  },
  methods: {
    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users.filter(user => user.isDeleted !== 1 && user.fs_user_id !== '' && user.fs_user_id !== null);
      });
    },
    getTicketTags() {
      ticketTags({}).then(res => {
        const problemTags = res.data.items;
        this.problemTags = problemTags;
        this.showTagList = this.removeDisabledFromTagList(problemTags);
      });
    },
    removeDisabledFromTagList(tagList) {
      for (let i = 0; i < tagList.length; i++) {
        tagList[i].disabled = false;
      }
      return tagList;
    },

    setFilter(filter) {
      this.filterForm = {
        ...filter
      };
      if (Array.isArray(this.filterForm.fields) && this.filterForm.fields.length > 0) {
        const fields = this.filterForm.fields
          .map(f => {
            return this.ticketFields.find(ff => ff.value === f);
          })
          .map(f => f.label);
        this.columns = [
          {
            key: 'action',
            align: 'center',
            width: 30,
            scopedSlots: { customRender: 'action' }
          }
        ];
        fields.forEach(f => {
          for (let i = 0; i < this.columnsCopy.length; i++) {
            if (this.columnsCopy[i].title === f) {
              this.columns.push(this.columnsCopy[i]);
            }
          }
        });
      } else {
        this.columns = this.columnsCopy;
      }
      if (!this.filterForm.time_field) {
        this.filterForm.time_field = 'created_time';
      }
      this.filterForm.pageSize = 20;
      this.overTime = 0;
      this.filterForm.pageNumber = 1;
      this.getProblemList();
    },
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    getUserById(user_id) {
      const user = this.userData.find(item => item.fs_user_id === user_id);
      return user.nickname;
    },
    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
      });
    },
    handleTabChange(key) {
      if (key === '2') {
        this.filterForm.pageSize = this.pagination.pageSize;
        this.filterForm.pageNumber = 1;
        this.queryOverTimeTicket();
      }
      if (key === '1') {
        this.filterForm.pageSize = this.pagination.pageSize;
        this.filterForm.pageNumber = 1;
        this.getProblemList();
      }
    },
    handleTableChange(filterForm) {
      this.filterForm.pageSize = filterForm.pageSize;
      this.filterForm.pageNumber = filterForm.pageNumber;
      this.getProblemList();
    },
    // 查看故障详情
    onViewFault(record) {
      this.$router.push({
        name: 'page:event:ticket:detail',
        query: { ticketId: record.id }
      });
    },

    onToFault(record) {
      this.sourceId = record.id;
      this.faultVisible = true;
    },

    toggle() {
      this.expand = !this.expand;
    },

    // 获取问题列表
    getProblemList() {
      this.loading = true;
      this.filterForm.isOverTime = 2;
      this.filterForm.type = [1];
      if (this.timeList.length > 0) {
        this.filterForm.startTime = moment(this.timeList[0]).format('YYYY-MM-DD');
        this.filterForm.endTime = moment(this.timeList[1]).format('YYYY-MM-DD');
      } else {
        this.filterForm.startTime = null;
        this.filterForm.endTime = null;
      }
      queryTickets(this.filterForm)
        .then(res => {
          this.tableData = res.data.ticketList;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    queryOverTimeTicket() {
      this.loading = true;
      this.filterForm.isOverTime = 1;
      queryTickets(this.filterForm)
        .then(res => {
          this.tableData = res.data.ticketList;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    reset() {
      this.filterForm = {
        pageSize: this.pagination.pageSize,
        pageNumber: 1,
        type: 1
      };
      this.getProblemList();
    },

    onSearch() {
      this.filterForm.pageNumber = 1;
      this.getProblemList();
    },

    // 关闭弹窗
    close(type) {
      this.modalVisible = false;
      this.faultVisible = false;
      if (type === 'submit') {
        this.getProblemList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .form-model-item .ant-input {
    width: 70%;
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
/deep/.is-fault.ant-tag {
  margin-right: 0;
}
</style>
